import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueSwal from 'vue-swal';
import VueClipboard from 'vue-clipboard2';
import VoerroTagsInput from '@voerro/vue-tagsinput';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
  faSpinner,
  faInfoCircle,
  faCopy,
  faTrash,
  faRobot,
  faEye,
  faLock,
  faUser,
  faUsers,
  faPlusCircle,
  faFileArchive,
  faImages,
  faVideo,
  faPlus,
  faPlayCircle,
  faStopCircle,
  faClipboardCheck,
  faLink,
  faCamera,
  faUndo,
  faGlobeAmericas
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App';

library.add(
  faExclamationTriangle,
  faSpinner,
  faInfoCircle,
  faCopy,
  faTrash,
  faRobot,
  faEye,
  faLock,
  faUser,
  faUsers,
  faPlusCircle,
  faFileArchive,
  faImages,
  faVideo,
  faPlus,
  faPlayCircle,
  faStopCircle,
  faClipboardCheck,
  faLink,
  faCamera,
  faUndo,
  faGlobeAmericas
);

Vue.use(VueSwal);
Vue.use(BootstrapVue);
Vue.use(VueClipboard);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('tags-input', VoerroTagsInput);

Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
});
